import { lazy } from 'react';

const UsedRoutes = [
  {
    path: 'used/products',
    component: lazy(() => import('views/used/products')),
  },
  {
    path: 'used/categories',
    component: lazy(() => import('views/used/categories')),
  },
];

export default UsedRoutes;
